export const SET_ACTIVE_USERS = "SET_ACTIVE_USERS";
export const SET_SELECTED_ACTIVE_USERS = "SET_SELECTED_ACTIVE_USERS";
export const SELECT_ALL_ACTIVE_USERS = "SELECT_ALL_ACTIVE_USERS";
export const SELECT_ACTIVE_USERS_BY_PROFILE = "SELECT_ACTIVE_USERS_BY_PROFILE";
export const SELECT_SINGLE_ACTIVE_USER = "SELECT_SINGLE_ACTIVE_USER";
export const SET_AGENTSPORTFOLIO = "SET_AGENTSPORTFOLIO";
export const SET_CLEAN_LIST_AGENT = "SET_CLEAN_LIST_AGENT";
